module.exports = __webpack_public_path__ + "img/deluxe.2b6b4211.jpg";